import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Entry, Asset } from 'contentful';

interface EntryImages {
  image?: Asset;
  twitterImage?: Asset;
}

interface SeoEntry extends EntryImages {
  title: string;
  description: string;
}

interface ArticleEntry extends EntryImages {
  heading: string;
  ingress: string;
}

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  constructor(private title: Title, private meta: Meta) {}

  updateMetaTags(entry: Entry<SeoEntry>) {
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    this.updateTitle(entry.fields.title);
    this.updateDescription(entry.fields.description);
    this.updateImage(entry);
  }

  updateArticleMetaTags(entry: Entry<ArticleEntry>) {
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    this.updateTitle(entry.fields.heading);
    this.updateDescription(entry.fields.ingress || '');
    this.updateImage(entry);
  }

  private updateTitle(title: string) {
    this.title.setTitle(title);
    this.meta.updateTag({
      property: 'og:title',
      content: title
    });
    this.meta.updateTag({
      name: 'twitter:title',
      content: title
    });
  }

  private updateDescription(description: string) {
    this.meta.updateTag({
      name: 'description',
      content: description
    });
    this.meta.updateTag({
      property: 'og:description',
      content: description
    });
    this.meta.updateTag({
      name: 'twitter:description',
      content: description
    });
  }

  private updateImage(entry: Entry<EntryImages>) {
    const image = entry.fields.image;
    const twitterImage = entry.fields.twitterImage
      ? entry.fields.twitterImage
      : image;

    if (image) {
      this.meta.updateTag({
        name: 'image',
        content: 'https:' + image.fields.file.url + '?w=1200&h=627',
      });
      this.meta.updateTag({
        property: 'og:image',
        content: 'https:' + image.fields.file.url + '?w=1200&h=627',
      });
    }

    if (twitterImage) {
      this.meta.updateTag({
        name: 'twitter:image',
        content: 'https:' + twitterImage.fields.file.url + '?w=1200&h=627',
      });
    }
  }
}
